import { z } from 'zod';

// kebab-case, reused for both folder and article slugs. Doubles as the folder's
// display name (matches the guide's taxonomy: `concerns`, `ingredients`, …).
export const KnowledgeSlugSchema = z
  .string()
  .regex(
    /^[a-z0-9]+(?:-[a-z0-9]+)*$/,
    'must be kebab-case (lowercase letters, digits, single hyphens)',
  );

export const KnowledgeFolderSchema = z.object({
  id: z.uuid(),
  parentId: z.uuid().nullable(),
  slug: KnowledgeSlugSchema,
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});
export type KnowledgeFolder = z.infer<typeof KnowledgeFolderSchema>;

// Browse-view node: the folder plus its derived path (joined ancestry slugs, e.g.
// `routines/actives`). Paths are derived, never stored (see the KB TRD §3.1).
export const KnowledgeFolderNodeSchema = KnowledgeFolderSchema.extend({
  path: z.string(),
});
export type KnowledgeFolderNode = z.infer<typeof KnowledgeFolderNodeSchema>;

export const CreateKnowledgeFolderSchema = z.object({
  parentId: z.uuid().nullable(),
  slug: KnowledgeSlugSchema,
});
export type CreateKnowledgeFolder = z.infer<typeof CreateKnowledgeFolderSchema>;

// Rename (`slug`) and/or move (`parentId`) — an omitted key leaves that dimension
// untouched; `parentId: null` moves the folder to the root.
export const UpdateKnowledgeFolderSchema = z.object({
  slug: KnowledgeSlugSchema.optional(),
  parentId: z.uuid().nullable().optional(),
});
export type UpdateKnowledgeFolder = z.infer<typeof UpdateKnowledgeFolderSchema>;
